import React from 'react'
import JoinContainer from '../../containers/auth/JoinContainer'
import PageTemplate from '../../components/common/PageTemplate'
import Breadcrumb from '../../components/common/Breadcrumb'
import PageHeaderContainer from '../../containers/common/PageHeaderContainer'
import PageTitleTemplate from '../../components/common/PageTitleTemplate'
import ContentTemplate from '../../components/common/ContentTemplate'
import { JOIN_PAGE } from '../../constants/page'

const JoinPage = () => {
  return (
    <PageTemplate className='member'>
      <PageHeaderContainer title='회원가입' image={require('../../assets/img/login/sub_tit_membership.png')} />
      <ContentTemplate className='sign_up_step1'>
        <PageTitleTemplate>
          <Breadcrumb page={JOIN_PAGE} />
        </PageTitleTemplate>
        <JoinContainer />
      </ContentTemplate>
    </PageTemplate>
  )
}

export default JoinPage
